module.exports = __webpack_public_path__ + "static/media/rjc.b76c20fe.jpg";